import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function FicheEditForm({ ficheId, onFinish }) {
  const [fiche, setFiche] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchFiche = async () => {
      const { data, error } = await supabase
        .from('fiches_pratiques')
        .select('*')
        .eq('id', ficheId)
        .single();

      if (error) {
        console.error(error);
        setMessage('Erreur de chargement.');
      } else {
        setFiche(data);
      }
    };
    fetchFiche();
  }, [ficheId]);

  const handleUpdate = async () => {
    if (!fiche) return;
    const { error } = await supabase
      .from('fiches_pratiques')
      .update({
        title: fiche.title,
        description: fiche.description,
        steps: fiche.steps,
        related_links: fiche.related_links,
      })
      .eq('id', fiche.id);

    if (error) {
      console.error(error);
      setMessage('Erreur lors de la mise à jour.');
    } else {
      setMessage('✅ Fiche mise à jour.');
      onFinish && onFinish();
    }
  };

  if (!fiche) return <p>Chargement...</p>;

  return (
    <div className="p-4 bg-white rounded-xl shadow max-w-xl space-y-4">
      <h2 className="text-xl font-bold">✏️ Modifier la fiche</h2>

      <input
        type="text"
        value={fiche.title || ''}
        onChange={(e) =>
          setFiche((prev) => ({
            ...prev,
            title: e.target.value,
          }))
        }
        className="w-full p-2 border rounded"
        placeholder="Titre"
      />

      <textarea
        value={fiche.description || ''}
        onChange={(e) =>
          setFiche((prev) => ({
            ...prev,
            description: e.target.value,
          }))
        }
        className="w-full p-2 border rounded"
        placeholder="Description"
      />

      {/* TODO: inputs pour steps et related_links si besoin */}

      <button
        onClick={handleUpdate}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Enregistrer
      </button>

      {message && <p className="text-sm mt-2">{message}</p>}
    </div>
  );
}
